/**
 * CreditsStep — optional credits-recharge step of the ProfileComplete v2.0 wizard.
 *
 * **Optional** by design. The user can skip and complete their profile
 * without buying any credits. The wizard footer (in ProfileComplete.js)
 * does not gate Next on this step.
 *
 * The RechargeBlock component handles its own state (balance + plans +
 * payment redirect) and is reused verbatim from the previous embedded
 * location inside PreviewStep. The Razorpay flow is unchanged — on a
 * successful purchase, the user is redirected back to /app/profile/complete
 * and lands on the same step with an updated balance.
 *
 * Skill compliance:
 *   - P20  one Card surface, plain section panels inside
 *   - P15  uniform white surface — no decorative card backgrounds
 *   - Hard rule 6 — no hex; severity Tags + var tokens only
 */
import { Message } from 'primereact/message';
import { Tag } from 'primereact/tag';
import RechargeBlock from './RechargeBlock';

const CreditsStep = ({ userId }) => (
    <div className="flex flex-column gap-3">
        {/* Header */}
        <div className="flex align-items-center justify-content-between gap-2 flex-wrap">
            <div>
                <h2 className="text-lg font-semibold text-900 m-0 mb-1">Credits</h2>
                <p className="text-600 text-sm m-0">
                    Top up credits now, or skip and add them anytime later.
                </p>
            </div>
            <Tag
                icon="pi pi-info-circle"
                severity="info"
                value="Optional"
                className="text-xs"
            />
        </div>

        {/* Reassurance banner — explicit "you can skip" so the user
            doesn't feel pressured to buy. Bharat Principle 5: design
            for freedom — clear escape route. */}
        <Message
            severity="info"
            text="This step is optional. You can complete your profile without buying credits and add them anytime later from your wallet."
            className="w-full"
        />

        {/* Existing recharge widget, untouched. */}
        <RechargeBlock userId={userId} />
    </div>
);

/* Static helpers — match the contract used by other step components.
   This step is OPTIONAL: validations always pass; no errors. */
CreditsStep.runValidations = () => ({});
CreditsStep.hasErrors      = () => false;

export default CreditsStep;
